import React from "react";
import { useContext } from "react";
import { EDataSelectListConfiguration } from "../components/EDataSelectList";
import { DirectoryContext } from "../directory-shared/DirectoryContext";
import { getTagDisplayName, inventoryEntityEquals } from "../functions/DataUtils";
import { SalesAgentService } from "./SalesAgentService";
import { SalesAgent } from "../models/entities/entities/sales-agent";
import { DataSelectInput, DataSelectInputPropsBase } from "hok-react";
import { EDataSelectWrapper } from "../components/DataSelectWrapper";

export function SalesAgentSelect
<G = never>
(props: DataSelectInputPropsBase<SalesAgent, G> &
    {
className?:string;
style?:React.CSSProperties;

})
{
    var oContext = useContext(DirectoryContext);
    var takeCount = 10;

    
    var config:EDataSelectListConfiguration<SalesAgent> = {

        takeCount: takeCount,
        getDisplayName:getTagDisplayName,
        equals:inventoryEntityEquals,
        getItems: (filter) =>{

                    
            var itemService = new SalesAgentService(oContext.http);

            var q = {

                skip:filter.currentIndex,
                take:takeCount,
                searchString: filter.searchString,
            };

            // filter.take = takeCount;
            return itemService.getList(q);
        }  
    };



    return <EDataSelectWrapper<SalesAgent, G> 
                group={props.group}
                groupKey={props.groupKey}
                value={props.value}
                onChange={props.onChange}
                name={props.name}
                readOnly={props.readOnly}
                required={props.required}

                
                
                className={props.className}
                style={props.style}
                configuration={config}
            />;
}